module.exports = __webpack_public_path__ + "img/1531958369.d778163f.jpg";